import React from "react";

import clsx from "clsx";

import {
  NotificationType,
  type MMMNotificationPill,
} from "./grouped-notifications";

export function Pill({
  text,
  onClick,
  type,
}: MMMNotificationPill & { type: NotificationType }) {
  return (
    <div
      className={clsx(
        "inline-flex justify-center items-center px-3 py-1 text-white",
        "rounded-full cursor-pointer",
        "max-w-max",
        "font-bold",
        {
          "bg-sun+1 hover:bg-sun+2": type === NotificationType.WARNING,
          "bg-alien+1 hover:bg-alien+2": type === NotificationType.INFO,
          "bg-mars+1 hover:bg-mars+2": type === NotificationType.DANGER,
        },
      )}
      onClick={onClick}
    >
      <span className="text-xs whitespace-nowrap">{text}</span>
    </div>
  );
}
